import getLocalString from "constants/Localization";
import { useGetReportCrewDetailsMutation } from "generated/graphql";

import useBitumioMutation from "hooks/useBitumioMutation";

const useGetReportCrewDetails = (showSuccessMessage: boolean = false) => {
  const [mutation, { loading, data, error }] = useGetReportCrewDetailsMutation();
  const [getReportCrewDetails, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getReportCrewDetails",
    },
    showSuccessMessage
      ? {
          successMessage: getLocalString("organization.generate-report-success"),
          failureMessage: getLocalString("organization.generate-report-failure"),
        }
      : {
          hideMessage: true,
        }
  );

  return [getReportCrewDetails, { ...context, data }] as const;
};

export default useGetReportCrewDetails;
